// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2JPa2","colMaxWidth":"Table_colMaxWidth__1IeUH"};